<template>
  <v-main :style="{background: '#FFF'}">
    <v-row justify="center">
      <v-col lg=4 md=6 sm=8 cols=12 class="pt-0 pb-0">
        <v-row justify="center">
          <v-col cols=12>
            <v-card
              class="mx-auto mb-6 pt-2"
              :color=backgroundColor
              light
              outlined
            >
              <AlertIndicatorsV2
              :dateRange="alertDateRange"
              :patients="alertPatients"
              :bed_rate="alertBedRate"
              :severe_bed_rate="alertSevereBedRate"
              :lastupdate=alertLastUpdateTime
              />
            </v-card>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-main>
</template>

<script>
import AlertIndicatorsV2 from './AlertIndicatorsC4OV2.vue'
import DataIndicators from '../statics/data/alert-indicators-2.json'

export default {
  name: 'AlertIndicatorsCard',
  components: {
    AlertIndicatorsV2,
  },
  computed: {
    alertDateRange: function() {
      return this.dataAlertIndicators.alertIndicators.date;
    },
    alertPatients: function() {
      return this.dataAlertIndicators.alertIndicators.patients;
    },
    alertBedRate: function() {
      return this.dataAlertIndicators.alertIndicators.bed_rate;
    },
    alertSevereBedRate: function() {
      return this.dataAlertIndicators.alertIndicators.severe_bed_rate;
    },
    alertLastUpdateTime: function() {
      return this.dataAlertIndicators.lastupdate;
    },
  },
  data: () => ({
    backgroundColor: '#FFF',
    dataAlertIndicators: DataIndicators,
  })
};
</script>

<style lang="sass">
.v-application 
  font-family: Hiragino Sans, sans-serif !important
</style>

<style scoped>
.p-0 {
  padding: 0px;
}

.pt-0 {
  padding-top: 0px;
}

.pb-0 {
  padding-bottom: 0px;
}

.pl-0 {
  padding-left: 0px;
}

.pr-0 {
  padding-right: 0px;
}

</style>
